import { render, staticRenderFns } from "./StatusDisplay.vue?vue&type=template&id=b9b49d70&scoped=true&"
import script from "./StatusDisplay.vue?vue&type=script&lang=js&"
export * from "./StatusDisplay.vue?vue&type=script&lang=js&"
import style0 from "./StatusDisplay.vue?vue&type=style&index=0&id=b9b49d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b49d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b49d70')) {
      api.createRecord('b9b49d70', component.options)
    } else {
      api.reload('b9b49d70', component.options)
    }
    module.hot.accept("./StatusDisplay.vue?vue&type=template&id=b9b49d70&scoped=true&", function () {
      api.rerender('b9b49d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/components/StatusDisplay.vue"
export default component.exports